import { createStore } from 'redux'
import throttle from 'lodash/throttle'
import * as storage from '../storage'
import mileageApp from '../reducers'

	const store = createStore(mileageApp,storage.getState());
	store.subscribe(throttle(()=>{
		console.log(store.getState());
		storage.saveState(store.getState())
	},1000))

	storage.firebase(store);

export default store;


// WEBPACK FOOTER //
// ./src/store/index.js